"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var typeWriteExtraction_1 = require("./typeWriteExtraction");
function TypeIt(props) {
    var element = typeWriteExtraction_1.useTypewriteLinesExtraction(props);
    var _a = react_1.useState(false), displayCursor = _a[0], setDisplayCursor = _a[1];
    react_1.useEffect(function () {
        var intervalToken = setInterval(function () {
            setDisplayCursor(function (oldDisplayCursor) { return !oldDisplayCursor; });
        }, 500);
        return function () { return clearInterval(intervalToken); };
    }, []);
    return (react_1.default.createElement("div", { style: { display: "inline-flex" }, className: (props === null || props === void 0 ? void 0 : props.className) || '' },
        element && element,
        react_1.default.createElement("div", { style: getCursorSyle(displayCursor, props === null || props === void 0 ? void 0 : props.style) })));
}
exports.TypeIt = TypeIt;
function TypeItInput(props) {
    return react_1.default.createElement("div", { style: __assign({}, props === null || props === void 0 ? void 0 : props.style) }, props.children);
}
exports.TypeItInput = TypeItInput;
var getCursorSyle = function (display, propsStyle) {
    if (display === void 0) { display = false; }
    if (propsStyle === void 0) { propsStyle = {}; }
    return __assign({ width: "3px", backgroundColor: (propsStyle === null || propsStyle === void 0 ? void 0 : propsStyle.color) || "black", MsTransition: "opacity 0.25s", WebkitTransition: "opacity 0.25s", MozTransition: "opacity 0.25s", transition: "opacity 0.25s", opacity: display ? 1 : 0, flex: 1 }, propsStyle);
};
//# sourceMappingURL=typeIt.js.map